<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                @invoke-method="invokeMethod($event)"
                                dialog-model="vendor_dialog"
                                perm="companies.create"
                            ></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetVendors(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>

                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="$t('lang.active_only')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="vendors" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openVendorForm(props.item)">
                                <td><img :src="props.item.logo" @error="imageLoadError" style="max-width: 50px; max-height: 50px" /></td>
                                <td>{{ props.item.company }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="vendors"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="vendor_dialog">
                <v-card>
                    <v-form ref="form_vendor">
                        <v-card-title>
                            <span class="headline">{{ vendor.company_id ? $t("lang.edit_vendor") : $t("lang.add_vendor") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeVendorDialog"
                                :dialog-status="vendor_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-form ref="form_vendor" @submit.prevent>
                                <v-container grid-list-form>
                                    <v-layout row wrap>
                                        <v-flex xs12>
                                            <v-text-field
                                                v-focus="vendor_dialog"
                                                v-model="vendor.company"
                                                :label="`${$t('lang.company')} *`"
                                                :counter="showCounter(vendor.company, 'vendor.company')"
                                                :rules="ifValid('vendor.company')"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="vendor.company_id" color="error" @mouseup.left="$refs.delete_vendors.openDialog()">{{ $t("lang.delete") }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeVendorDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveVendors">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_vendors"
                :heading="$t('lang.delete_vendor')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteVendors(vendor.company_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import AppConfig from "Constants/AppConfig";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openVendorForm" },
                { title: this.$t("lang.refresh"), action: "dbGetVendors", params: [true] },
            ],
            headers: [{ text: "", sortable: false, align: "center", width: "60" }, { text: this.$t("lang.vendor"), sortable: false }],
            vendor: {},
            filter: {
                search: "",
                company_id: "",
                status: "1",
            },
            vendor_dialog: false,
            dbGetVendors: _.debounce(this.getVendors, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchVendors", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.vendors) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchVendors({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.vendors) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.vendors.vendors_filter,
            page: (state) => state.vendors.page,
            rules_vendors: (state) => state.vendors.rules_vendors,
            vendor_status_options: (state) => state.settings.vendor_status_options,
            vendors: (state) => state.vendors.vendors,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchVendors", "saveVendor", "deleteVendor"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openVendorForm(item = null) {
            if (item != null) {
                this.$router.push({ name: "vendor", params: { id: item.company_id } });
            } else {
                this.$router.push({ name: "vendor" });
            }
        },
        saveVendors() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_vendor")) {
                    let body = this.prepForm(this.vendor, this.rules_vendors);

                    this.saveVendor({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            this.$router.push({ name: "vendor", params: { id: data.vendor.company_id } });
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteVendors(id = null) {
            this.deleteVendor({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getVendors();
                    this.closeVendorDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeVendorDialog() {
            this.vendor_dialog = false;
            this.$refs.delete_vendors.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        imageLoadError(event) {
            event.target.src = AppConfig.defaultProfileLogo;
        },
        getVendors(pg_refresh = false) {
            this.startLoader();

            this.fetchVendors({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.vendor_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
    },
};
</script>
